import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';


class SegmentSubCategory extends BaseApi {
	saveSegmentSubCategoryData(dto: any) { return this.post(`/${DMS_MODULE}/${NAME}/SaveSegmentSubCategory`, dto); }
	deleteSegmentSubCategoryData(id: any) { return this.delete(`/${DMS_MODULE}/${NAME}/DeleteSegmentSubCategory?Id=${id}`); }
}
export const apiProvider = new SegmentSubCategory(DMS_MODULE, NAME);
